function uheprng() {
	return (function() {
  		var o = 48;					
		var c = 1;					
		var p = o;					
		var s = new Array(o);	
		var i,j,k=0;				

		var mash = Mash();		// get a pointer to our high-performance "Mash" hash
		for (i = 0; i < o; i++) s[i] = mash( Math.random() );	// fill the array with initial mash hash values

		function rawprng() {
			if (++p >= o) p = 0;
			var t = 1768863 * s[p] + c * 2.3283064365386963e-10; // 2^-32
      	return s[p] = t - (c = t | 0);
		};

		var random = function( range ) {
			return Math.floor(range * (rawprng() + (rawprng() * 0x200000 | 0) * 1.1102230246251565e-16)); // 2^-53
		};

		random.string = function( count ) {
			var i, s='';
			for ( i=0; i<count; i++ ) s += String.fromCharCode( 33+random(94) );
			return s;
		};

		function hash() {
			var args = Array.prototype.slice.call(arguments)
			for (i = 0; i < args.length; i++) {
				for (j = 0; j < o; j++) {
					s[j] -= mash(args[i]);
					if (s[j] < 0) s[j] += 1;
				}
			}
		};

		random.cleanString = function( inStr ) {
			inStr = inStr.replace(/(^\s*)|(\s*$)/gi,""); // remove any/all leading spaces
			inStr = inStr.replace(/[\x00-\x1F]/gi,"");	// remove any/all control characters
			inStr = inStr.replace(/\n /,"\n");				// remove any/all trailing spaces
			return inStr;											// return the cleaned up result
		}

		random.hashString = function( inStr ) {
			inStr = random.cleanString( inStr );
			mash( inStr );											// use the string to evolve the 'mash' state
			for ( i = 0; i < inStr.length; i++) {			// scan through the characters in our string
				k = inStr.charCodeAt( i );						// get the character code at the location
				for (j = 0; j < o; j++) {						//	"mash" it into the UHEPRNG state
					s[j] -= mash( k );
					if (s[j] < 0) s[j] += 1;
				}
			}
		};

		// this handy exported function is used to add entropy to our uheprng at any time
		random.addEntropy = function( /* accept zero or more arguments */ ) {
			var args = [];
			for ( i = 0; i < arguments.length; i++ ) args.push( arguments[i] );
			hash( (k++) + (new Date().getTime()) + args.join('') + Math.random() );
		};

		random.initState = function() {
			mash();													// pass a null arg to force mash hash to init
			for (i = 0; i < o; i++) s[i] = mash( ' ' );	// fill the array with initial mash hash values
			c = 1;													// init our multiply-with-carry carry
			p = o;													// init our phase
		};

		random.done = function() {
			mash = null;
		};

		return random;
  } ());
};


function Mash() {
	var n = 0xefc8249d;
	var mash = function(data) {
		if ( data ) {
			data = data.toString();
			for (var i = 0; i < data.length; i++) {
				n += data.charCodeAt(i);
				var h = 0.02519603282416938 * n;
				n = h >>> 0;
				h -= n;
				h *= n;
				n = h >>> 0;
				h -= n;
				n += h * 0x100000000; // 2^32
			}
			return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
		} else n = 0xefc8249d;
	};
  return mash;
}


smaller = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight;

function prettyRaCo(){
    var colorWheel =  Math.floor(Math.random()*6);

    var color = "rgb(";
    var randomNumber =  Math.floor(Math.random()*256);
    if(colorWheel ==0)
    color= color+ "0,255,"+randomNumber+")";
     if(colorWheel ==1)
    color= color+ "0,"+randomNumber+",255)";
     if(colorWheel ==2)
    color= color+ "255, 0,"+randomNumber+")";
     if(colorWheel ==3)
    color= color+ "255,"+randomNumber+",0)";
     if(colorWheel ==4)
    color= color+ randomNumber+",255,0)";
     if(colorWheel ==5)
    color= color+ randomNumber+",0,255)";
    return color;
}
function fillIrregularQuad(path,hatches){
  var pts = path.segments.map(function(e){return e.point});
  console.log(pts)
  var track = new paper.Path({segments: [pts[1],pts[2]]});
  var across = new paper.Path({segments: [pts[0],pts[3]]});
  var stripes = new paper.Group();
  for (var i = 0; i < hatches; i++) {
    stripes.children.push(new paper.Path());
    stripes.children[i].add(track.getPointAt(i*(track.length/hatches)));
    stripes.children[i].add(across.getPointAt(i*(across.length/hatches)));
  }
  return stripes;
}
function colorWheel(entry)
        {
            var key;
            if(entry<0)
              entry = 1535-(-entry%1535)
            else
              entry = entry%1535
            var text = "rgb(";
            var num = entry%256;
            if(entry >= 0 && entry < 256)
            	text= text+ "0,255,"+num+")";
            else if(entry>255 && entry<512)
				text= text+ "0,"+(255-num)+",255)";
			else if(entry>511 && entry<768)
            	text= text+ num +",0,255)";
			else if(entry>767 && entry<1024)
            	text= text+ "255,0,"+(255-num)+")";
            else if(entry>1023 && entry<1280)
            	text= text+ "255,"+num+",0)";
            else if(entry>1279 && entry<1535)
            	text= text+ (255-num)+",255,0)";
            return text;
        }
 function prettyRaCo2(whiteness)
        {
            var key =  Math.floor(Math.random()*6);
            var text = "rgb(";
            var num =  Math.floor(Math.random()*256);
            whiteness = whiteness%255;
            if(key ==0)
            text= text+ "0,255,"+whiteness+")";
             if(key ==1)
            text= text+ "0,"+whiteness+",255)";
             if(key ==2)
            text= text+ "255, 0,"+whiteness+")";
             if(key ==3)
            text= text+ "255,"+whiteness+",0)";
             if(key ==4)
            text= text+ whiteness+",255,0)";
             if(key ==5)
            text= text+ whiteness+",0,255)";
            return text;
        }
function ranHex(){
	var str = '#';
	var colors = ['ff','ff','ff']
	var which = Math.floor(Math.random()*3);
	var tokens = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f']
	colors[which] = '00';
	var which2 = Math.floor(Math.random()*3);
	while(which === which2){
		which2 = Math.floor(Math.random()*3);
	}
	colors[which2] = 'ff';
	var which3 = Math.floor(Math.random()*3);
	while(which3 === which || which3 === which2){
		which3 = Math.floor(Math.random()*3);
	}
	colors[which3] = tokens[Math.floor(Math.random()*tokens.length)] +
		tokens[Math.floor(Math.random()*tokens.length)]
	str+= colors[0]+colors[1]+colors[2]
	return str;

}

Array.matrix = function(m,n,initial) {
	var a,i ,j,mat = [];
	for(i =0; i < m;i+=1){
		a = [];
		for(j = 0; j < n; j += 1) {
			a[j] = initial;
		}
		mat[i] = a;
	}
	return mat
};

function num(range){
  return Math.floor(Math.random()*range);
}
function numH(){
  return Math.floor(Math.random()*view.size.height);
}
function numW(){
  return Math.floor(Math.random()*view.size.width);
}

function downloadAsPNG(fileName, canv) {
  var canvazz = document.getElementById(canv);
  var dataURL = canvazz.toDataURL();
  var link = document.createElement("a");
  link.download = fileName;
  link.href = dataURL;
  link.click();
}

function downloadAsSVG(fileName) {

   if(!fileName) {
       fileName = "paperjs_example.svg"
   }
   //console.log(paper.project.exportSVG({asString:true}))
   var url = "data:image/svg+xml;utf8," + encodeURIComponent(paper.project.exportSVG({asString:true}));

   var link = document.createElement("a");
   link.download = fileName;
   link.href = url;
   link.click();
}


if(window.hasOwnProperty('paper'))
	{

	paper.Path.prototype.prt = function(wheel){
	if(wheel===undefined)
		this.fillColor = prettyRaCo();
	else
		this.fillColor = colorWheel(wheel);
	}
	paper.Path.prototype.grid = function(x,y,size){
		var columns = [];
		var groups = [];
		var offset = Math.floor(Math.random()*1536)
		width = window.innerWidth/x;
		height = window.innerHeight/y;
		if(size!==undefined){
			width = size;
			height = size;
			x = Math.ceil(window.innerWidth/size);
			y = Math.ceil(window.innerHeight/size);
		}
		for(var i=0;i<x;i++){
			columns[i] = [];
			groups[i] = new paper.Group();
			for(var j=0;j<y;j++){
				columns[i][j] = new paper.Path.Rectangle(i*width,j*height,width,height);
				columns[i][j].fillColor = colorWheel(offset+((i*j)/(x*y)*1536));//prettyRaCo();
				columns[i][j].scale(2)
				groups[i].children.push(columns[i][j]);
				}
			groups[i].scale(3);

		}
		this.columns = columns;
		return groups;
}
}
  function grid(x,y,size){
    var columns = [];
		var groups = [];
		var offset = Math.floor(Math.random()*1536)
		width = window.innerWidth/x;
		height = window.innerHeight/y;
		if(size!==undefined){
			width = size;
			height = size;
			x = Math.ceil(window.innerWidth/size);
			y = Math.ceil(window.innerHeight/size);
		}
		for(var i=0;i<x;i++){
			columns[i] = [];
			groups[i] = new paper.Group();
			for(var j=0;j<y;j++){
				columns[i][j] = new paper.Path.Rectangle(i*width,j*height,width,height);
				columns[i][j].fillColor = colorWheel(offset+((i*j)/(x*y)*1536));//prettyRaCo();
				//columns[i][j].scale(2)
				groups[i].children.push(columns[i][j]);
				}
			//groups[i].scale(3);

		}
		this.columns = columns;
		return groups;
  }

  function makeGrid(x,y,point,bounds){
    var columns = [];
    var groups = [];
    var offset = Math.floor(Math.random()*1536)
    width = bounds.width/x;
    height = bounds.height/y;
    for(var i=0;i<x;i++){
      columns[i] = [];
      groups[i] = new paper.Group();
      for(var j=0;j<y;j++){
        columns[i][j] = new paper.Path.Rectangle(point.x+i*width,point.y+j*height,width,height);
        columns[i][j].fillColor = colorWheel(offset+((i*j)/(x*y)*1536));//prettyRaCo();
        //columns[i][j].scale(2)
        groups[i].children.push(columns[i][j]);
        }
      //groups[i].scale(3);

    }
    this.columns = columns;
    return groups;
  }

  //if(window.paper)
  //console.dir(paper.Path.prototype)

  if(window.paper!==undefined){
    function biggestSquare(bounds){
    	var sq;
    	if(bounds.width>bounds.height)
    		sq = new Path.Rectangle((bounds.width-bounds.height)/2,0,bounds.height,bounds.height)
    	else
    		sq = new Path.Rectangle(0,(bounds.height-bounds.width)/2,bounds.width,bounds.width)
    	return sq.bounds;
    }
    window.gradient = function(item, colors,origin,dest){
      item.fillColor = {
      		gradient:{
      			stops: colors},
      			origin: (origin !== undefined ? origin : [0,screen.availHeight]),
      			destination: (dest !== undefined ? dest : [screen.availWidth,screen.availHeight])
      					};
    }
    window.paper.Group.delete = function(){
      console.log(this.children);
    }
  }

  function throt(func,count){
    for(var i=0;i<count;i++){
      func(i);
    }
  }

function fit(item){
  if(view.bounds.width>view.bounds.height){
    item.bounds.width = view.bounds.width;
    item.bounds.height = view.bounds.width;
  }
  else{
    item.bounds.width = view.bounds.height;
    item.bounds.height = view.bounds.height;
  }
  item.bounds.center = view.bounds.center;
}

